import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemCommonProps } from '.';
import { dormitoryBaseFeeRule } from '../rules';

export const DormitoryBaseFeeFormItem = ({ disabled }: FormItemCommonProps) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('Base fee')}
      name="base"
      rules={[dormitoryBaseFeeRule()]}
    >
      <Input type="number" min="0" max="9999" disabled={disabled} />
    </Form.Item>
  );
};
